var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92333 22.639L16.136 33.5511L24.3488 22.639H19.7757V14.4066H12.4963V22.639H7.92333Z",
    fill: "#186AB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6511 0H4.62093C2.07293 0 0 2.06518 0 4.60351V44.3878C0 46.931 2.06901 49 4.61222 49H27.6598C30.203 49 32.2721 46.931 32.2721 44.3878V4.60351C32.2721 2.06518 30.1991 0 27.6511 0V0ZM1.91406 4.60351C1.91406 3.1205 3.12834 1.91406 4.62093 1.91406H27.6512C29.1438 1.91406 30.3581 3.1205 30.3581 4.60351V39.4458H1.91406V4.60351ZM30.358 44.3878C30.358 45.8755 29.1476 47.0859 27.6598 47.0859H4.61222C3.12442 47.0859 1.91406 45.8756 1.91406 44.3878V41.3598H30.3581V44.3878H30.358Z",
    fill: "#186AB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.498 45.1799H16.7742C17.3027 45.1799 17.7312 44.7514 17.7312 44.2229C17.7312 43.6943 17.3027 43.2658 16.7742 43.2658H15.498C14.9696 43.2658 14.541 43.6943 14.541 44.2229C14.541 44.7514 14.9696 45.1799 15.498 45.1799Z",
    fill: "#186AB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6809 3.78534H11.5911C11.0627 3.78534 10.6341 4.2138 10.6341 4.74237C10.6341 5.27094 11.0627 5.6994 11.5911 5.6994H20.6809C21.2094 5.6994 21.6379 5.27094 21.6379 4.74237C21.6379 4.2138 21.2095 3.78534 20.6809 3.78534Z",
    fill: "#186AB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobileIcon.df6816cc.svg";
export { ForwardRef as ReactComponent };